/*global  jQuery*/

jQuery(function ($) {
  "use strict";
  
  $(window).on("load", function () {
    /* 
    --------------------------------------
     ページ遷移を伴う頭出しの位置調整　ヘッダー固定時に使用
    --------------------------------------
    */
//    var wkhash=window.location.hash
//    if( wkhash != ""){
//      var windowWidth = window.innerWidth;
//      if( windowWidth > 991 ){
//        $(wkhash).velocity("scroll", {duration:500,offset:-94});  //ヘッダーサイズをオフセット
//      }else {
//        $(wkhash).velocity("scroll", {duration:500,offset:-48});  //ヘッダーサイズをオフセット　スマホ時
//      }
//    }
    /* 
    --------------------------------------
     HeightLine 要heightline.js
     高さを揃えるクラスを指定する 
    --------------------------------------
    */
    $(".foo").heightLine({minWidth: 750});    
  });
  /* 
  --------------------------------------
   ロールオーバー　画像切替
   easyRollover
  --------------------------------------
  */
  // 通常
  $('.rollover').easyRollover();
  // サフィックス
  $('.rollover-suffix').easyRollover({
    suffix: '_off.',
    suffix_replace: '_on.'
  });
  // 透過フェードするだけのロールオーバー
  $('.rollover-fade1').easyRollover({
    suffix: false,
    transition: 'fade',
    opacity: 0.2,
    duration: 400
  });
  // フェードして切り替わるロールオーバー
  $('.rollover-fade2').easyRollover({
    suffix: '_off.',
    suffix_replace: '_on.',
    transition: 'fade',
    duration: 200,
    easing: 'swing'
  });
  /* 
  --------------------------------------
   モーダル
   colorbox
  --------------------------------------
  */
  $("a[rel='colorbox-group']").colorbox({
    iframe: false,
    inline: false,
    maxWidth: "80%",
    maxHeight: "80%",
    opacity: 0.7
  });
  $("a[href$='.jpg'],a[href$='.png'],a[href$='.jpeg']").colorbox({
    iframe: false,
    inline: false,
    maxWidth: "80%",
    maxHeight: "80%",
    opacity: 0.7
  });
  $("a.popup").colorbox({
    iframe: false,
    inline: true,
    maxWidth: "60%",
    maxHeight: "80%",
    opacity: 0.7
  });  
  /*
  --------------------------------------
   スクロール処理
   waypoint
  --------------------------------------
  */
  $(".demo-waypoint").waypoint(function () {
    $(".demo-waypoint").addClass("animated rubberBand");
  }, { offset: '20%' });
  /*
  --------------------------------------
   スムーズスクロール
   #で始まるアンカーをクリックした場合に処理
   必要に応じて除外する要素を追記すること
  --------------------------------------
  */
  $(document).on('click', 'a[href*=\\#]:not([href=\\#])', function (event) {
      // アンカーの値取得
      var href = $(this).attr("href"),
      // 移動先を取得 velocity
      target = $(href === "#" || href === "" ? 'html' : href);
    // スムーススクロール
    target.velocity("scroll", 500);
    // 移動先を数値で取得 animate
//    target = $(href === "#" || href === "" ? 'html' : href),
//    position = target.offset().top;
    // スムーススクロール
//    $('body,html').animate({scrollTop: position}, speed, 'swing');
    return false;
  });
  //ページトップ戻るボタン 動作
  $(document).on("click", "#btn-pagetop", function () {
    $('body,html').velocity("scroll", 500);
    return false;
  });
  //ページトップ戻るボタン 表示ギミック
  $(window).scroll(function () {
    if ($(this).scrollTop() > 100) {
      $("#btn-pagetop").fadeIn(300);
    } else {
      $("#btn-pagetop").fadeOut(300);
    }
  });
  /* 
  --------------------------------------

   サイドバー追従処理

  --------------------------------------
  */
  /* Window幅取得 */
  // var windowWidth = window.innerWidth,
  //   customTopPosition = 0,
  //   target = $(".fixed-item"),
  //   footer = $("footer");
  // /* targetが存在ている場合のみ処理する */
  // if (target[0]) {
  //   var targetHeight = target.outerHeight(true),
  //     targetTop = target.offset().top;
  //   /*  */
  //   $(window).scroll(function(){
  //     if(windowWidth > 991){
  //       var scrollTop = $(this).scrollTop();
  //       if(scrollTop > targetTop){
  //         // 動的にコンテンツが追加されてもいいように、常に計算する
  //         var footerTop = footer.offset().top;
  //         if(scrollTop + targetHeight > footerTop){
  //           customTopPosition = footerTop - (scrollTop + targetHeight)
  //           target.css({position: "fixed", top:  customTopPosition + "px"});
  //         }else{
  //           target.css({position: "fixed", top: "0px"});
  //         }
  //       }else{
  //         target.css({position: "static", top: "auto"});
  //       }
  //     }else {
  //       target.css({position: "static", top: "auto"});
  //     }
  //   });
  //   /* リサイズ時に再計算 */
  //   $(window).resize(function(){
  //     windowWidth = window.innerWidth;
  //     if(windowWidth > 991){
  //       var scrollTop = $(this).scrollTop();
  //       if(scrollTop > targetTop){
  //         // 動的にコンテンツが追加されてもいいように、常に計算する
  //         var footerTop = footer.offset().top;
  //         if(scrollTop + targetHeight > footerTop){
  //           customTopPosition = footerTop - (scrollTop + targetHeight)
  //           target.css({position: "fixed", top:  customTopPosition + "px"});
  //         }else{
  //           target.css({position: "fixed", top: "10px"});
  //         }
  //       }else{
  //         target.css({position: "static", top: "auto"});
  //       }
  //     }else {
  //       target.css({position: "static", top: "auto"});
  //     }
  //   });
  // }
  /* 
  --------------------------------------

  スマホ用メニュー処理

  --------------------------------------
  */    
  /* iOS動作時の調整処理 */
  $(document).on("touchstart", ".menu-close", function (event) {
    event.stopPropagation();
  });
  /* ハンバーガーメニューによる開閉処理 */
  $(document).on("click", ".sp-menu-btn.menu-close", function () {
      $(".sp-menu").addClass("open");
      $(".main-contents").addClass("open");
      $(".sp-menu").removeClass("close");
      $(".sp-menu-btn").addClass("menu-open");
      $(".sp-menu-btn").removeClass("menu-close");
  });
  $(document).on("click", ".sp-menu-btn.menu-open,.main-contents.open,.btn-sp-menu-close", function () {
      $(".sp-menu").addClass("close");
      $(".sp-menu").removeClass("open");
      $(".main-contents").removeClass("open");
      $(".sp-menu-btn").removeClass("menu-open");
      $(".sp-menu-btn").addClass("menu-close");
  });
  /* ハンバーガーメニューによる開閉処理 */
  $(document).on("click", ".parent_toggle.close", function () {
    $(this).siblings(".sub-menu").slideToggle();
      $(this).addClass("open");
      $(this).removeClass("close");
      $(this).parent().next("ul").slideToggle();
  });
  $(document).on("click", ".parent_toggle.open", function () {
    $(this).siblings(".sub-menu").slideToggle();
      $(this).addClass("close");
      $(this).removeClass("open");
      $(this).parent().next("ul").slideToggle();
  });

  $('.menu-item-has-children').prepend('<span class="parent_toggle close"></span>');

});